export default "__VITE_ASSET__Yb3BlFNb__"